import {User} from "../../../services/UsersService";
import LoginUsers from "../LoginUsers";

interface LoginUsersTabProps {
  readonly user: User;
}

const LoginUsersTab = (props: LoginUsersTabProps) => {
  const {user} = props;
  return (
    <div className="row align-items-center">
      <LoginUsers userId={user.id} />
    </div>
  );
};

export default LoginUsersTab;
